<template>
  <me-combo-select v-bind="$props" v-on="$listeners" :data="comboData" />
</template>
<script>

import http from '@common/ExtendHttp'
import comboMixin from '../mixins/combo.mixin'
export default {
  name: 'ComboSelectSystem',
  mixins: [ comboMixin ],
  props: {
    pathName: {
      type: String, default: '/basic/system/select/list/all'
    }
  },
  data () {
    return {
      comboData: [],
      eventName: 'refresh--comno-select-system'
    }
  },
  created () {
    this.$eventMonitor.register(this.eventName, data => {
      http.get(this.pathName).then(data => {
        this.comboData = data || [ ]
      })
    })
    this.$eventMonitor.dispatch(this.eventName)
  }
}
</script>
